import { render, staticRenderFns } from "./SFXEditAssembly.vue?vue&type=template&id=8ff43c44&"
import script from "./SFXEditAssembly.vue?vue&type=script&lang=js&"
export * from "./SFXEditAssembly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports